(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('IndividualMeterDialogController', IndividualMeterDialogController);

    IndividualMeterDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'IndividualMeter', 'Cluster','ModelMeter'];

    function IndividualMeterDialogController ($scope, $stateParams, $uibModalInstance, entity, IndividualMeter, Cluster,ModelMeter) {
        var vm = this;
        vm.individualMeter = entity;
        vm.mapMeter = createMapMeter(vm.individualMeter);
        vm.clusters = Cluster.queryActif({ offset: 0,size: 1000});
        vm.modelMeters = ModelMeter.query({ offset: 0,size: 1000});
        vm.load = function(id) {
            IndividualMeter.get({id : id}, function(result) {
                vm.individualMeter = result;
                vm.mapMeter = createMapMeter(vm.individualMeter);
            });
        };

        if (vm.individualMeter && vm.individualMeter.$promise) {
            vm.individualMeter.$promise.then(function() {
                vm.mapMeter = createMapMeter(vm.individualMeter);
            });
        }

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:individualMeterUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            syncMapMeter();
            if (vm.individualMeter.id !== null) {
                IndividualMeter.update(vm.individualMeter, onSaveSuccess, onSaveError);
            } else {
                IndividualMeter.save(vm.individualMeter, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dateMiseEnService = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };

        function createMapMeter(individualMeter) {
            return {
                lat: parseCoordinate(individualMeter && individualMeter.latitude),
                lon: parseCoordinate(individualMeter && individualMeter.longitude),
                referenceContrat: individualMeter && individualMeter.numeroSerie ? individualMeter.numeroSerie : ''
            };
        }

        function parseCoordinate(value) {
            if (value === null || value === undefined || value === '') {
                return null;
            }

            var parsedValue = Number(String(value).replace(',', '.'));
            return isNaN(parsedValue) ? null : parsedValue;
        }

        function formatCoordinate(value) {
            if (value === null || value === undefined || value === '') {
                return null;
            }

            return String(value);
        }

        function syncMapMeter() {
            vm.individualMeter.latitude = formatCoordinate(vm.mapMeter && vm.mapMeter.lat);
            vm.individualMeter.longitude = formatCoordinate(vm.mapMeter && vm.mapMeter.lon);

            if (vm.mapMeter) {
                vm.mapMeter.referenceContrat = vm.individualMeter.numeroSerie;
            }
        }
    }
})();
